export { default } from './InputRadioGroup';
